import StoryBuyNow from 'assets/SVG/StoryBuyNow'
import langData from 'lang/data'
import { Link } from 'react-router-dom'

const BuyNow = ({ id, buy_now, url, nameTrimmed, descriptionTrimmed, currentLanguage, handleBuyNow, handleLike }) => {
    return (
        <div className='StoryInfoContainer vieweInfo'>
            <Link to={url}>
                <div className='StoryTextContainer'>
                    {nameTrimmed && (
                        <h2 className='StoryTitle'>{nameTrimmed}</h2>
                    )}
                    {descriptionTrimmed && (
                        <p className='StoryDescription'>{descriptionTrimmed}</p>
                    )}
                </div>
            </Link>
            {buy_now ? (
                <button
                    className='StoryBuyNow'
                    onClick={() => handleBuyNow(id)}
                >
                    <StoryBuyNow className='StoryBuyNowIcon' />
                    {langData.buttons.buy_now[currentLanguage]}
                </button>
            ) : null}
        </div>
    )
}

export default BuyNow